import { FlexBox, Text } from '@fable/components'
import { css, cx, useTheme } from '@fable/theme'
import { GridCalloutCard, GridCalloutTheme } from './types'
import { useScroll, useTransform, motion } from 'framer-motion'
import { useRef } from 'react'

interface Props {
  cards: GridCalloutCard[]
  theme: GridCalloutTheme
}

export const GridCalloutRow = ({ theme, cards }: Props) => {
  const { colors, mediaQueries } = useTheme()
  const ref = useRef(null)
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['-50% end', 'center 75%'],
  })

  const opacity = useTransform(scrollYProgress, [0, 0.5, 1], [0, 0, 1])
  const y1 = useTransform(scrollYProgress, [0, 1], [200, 0])
  const y2 = useTransform(scrollYProgress, [0, 1], [400, 0])
  const y3 = useTransform(scrollYProgress, [0, 1], [100, 0])
  const y4 = useTransform(scrollYProgress, [0, 1], [300, 0])

  const getMotionStyles = (i: number) => {
    switch (i) {
      case 0:
        return { y: y1, opacity }
      case 1:
        return { y: y2, opacity }
      case 2:
        return { y: y3, opacity }
      case 3:
        return { y: y4, opacity }
    }
  }

  return (
    <div
      ref={ref}
      className={css`
        margin-top: 40px;
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;
        &:not(:last-child) {
          margin-bottom: 160px;
        }
        ${mediaQueries.mobileL} {
          margin-top: 32px;
          grid-template-columns: repeat(4, 1fr);
        }
        ${mediaQueries.tabletL} {
          gap: 32px;
        }
      `}
    >
      {cards.map((card, i) => (
        <motion.div key={i} style={getMotionStyles(i)}>
          <FlexBox
            className={css`
              gap: 20px;
              ${mediaQueries.mobileL} {
                gap: 32px;
              }
            `}
            flexDirection="column"
            alignItems="center"
          >
            <FlexBox
              className={css`
                width: 100%;
                aspect-ratio: 1 / 1;
                border-radius: max(2.778vw, 24px);
                background-color: ${theme.dark};
                ${mediaQueries.desktop} {
                  border-radius: 32px;
                }
              `}
            >
              <img
                className={css`
                  display: block;
                  width: 100%;
                `}
                src={card.image}
                alt={card.altText}
              />
            </FlexBox>
            <Text
              className={cx(
                css`
                  max-width: 172px;
                `,
                'fds--grid-callout-card__title'
              )}
              tag="p"
              type="subhead"
              sizing={{ base: 'XS', mobile: 'S', tabletL: 'M' }}
              align="center"
              color={colors.uiGraphite}
            >
              {card.text}
            </Text>
          </FlexBox>
        </motion.div>
      ))}
    </div>
  )
}
